'use client'

import { useTranslations } from 'next-intl'
import PlusIcon from '../icons/PlusIcon'
import CalendlyEmbed from './CalendlyEmbed'
import Card from './Card'

const CTACard = () => {
  const t = useTranslations('cta')

  return (
    <Card tag="section" direction="row" className="cta-card flex-col! p-12 lg:p-16 bg-accent gap-16 col-span-full!">
      <h2 className="font-medium text-2xl leading-none w-full lg:text-[32px] lg:leading-8">{t('title')}</h2>
      <p className="text-lg leading-6">{t('description')}</p>
      {/* Bewusst das Popup-Widget statt eines externen Links im neuen Tab:
          nur so greift der calendly.event_scheduled-Listener aus CalendlyEmbed
          und eine gebuchte Beratung wird als Conversion messbar. */}
      <CalendlyEmbed variant="popup" className="w-full lg:w-fit cursor-pointer text-left">
        <Card direction="row" className="mt-8 lg:mt-0 bg-white p-8 w-full lg:w-fit cursor-pointer gap-8">
          <PlusIcon size={20} className="text-accent" />
          <p className="font-medium text-KMRS-Darkmode leading-6 text-lg">{t('button')}</p>
        </Card>
      </CalendlyEmbed>
    </Card>
  )
}

export default CTACard
